"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_network__signal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "e2c50020-0971-48bc-aa26-0af83b7d4a47",
    x1: 70.38,
    y1: 128.97,
    x2: 121.53,
    y2: 180.13,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  }))), /*#__PURE__*/React.createElement("title", null, "network-hi"), /*#__PURE__*/React.createElement("g", {
    id: "cf0a6647-5c9e-4886-a129-e7e81bd25f57",
    "data-name": "network-hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3587e082-75ed-4da0-9b0b-c58462d2b18d",
    "data-name": "Apps_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f20f82cd-4e1a-4b68-a3e5-19e279eabada",
    "data-name": "Bill_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "dd184c69-95e1-4eac-910c-ec0e018100b5",
    "data-name": "Report_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "97d40bd7-f6d4-437b-9450-4c11869f0ac8",
    "data-name": "vodafone_store_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "3205c688-21bd-4173-ad95-fd8712eb89fa",
    "data-name": "Broadband_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "95b930e0-0357-4d9d-9fc3-d29863756c1b",
    "data-name": "Business_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a97925ef-a1a9-40f1-9647-b60ce19624ab",
    "data-name": "Calendar_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "9d2aebea-39ab-45cb-858d-51fd15742355",
    "data-name": "Camera_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "a44090b1-1879-404c-96e8-fda651b78578",
    "data-name": "Data_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "cc84bb1e-c350-41a5-853e-961a393ebbe2",
    "data-name": "Desktop_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ed635b8a-da5a-4fef-80d2-f8c6797f6a8d",
    "data-name": "Document_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e72b4ac6-6b0c-4faa-9747-a26e42973c96",
    "data-name": "Edit_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "e2e96233-ff49-426d-9ac2-d5dff1404d52",
    "data-name": "Enterprise_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6fbb2662-8f4f-441c-ae7e-3104a1947e75",
    "data-name": "Call_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "7fb73d06-b9a4-4876-9ba6-29130730fd7f",
    "data-name": "Location_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8c7eff87-802f-42d5-b6e7-ea58a40fc12e",
    "data-name": "Mail_new_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "39f487a9-1263-451b-ba79-16780782b9b6",
    "data-name": "Mail_unread_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "f73383dc-784e-4b95-9599-85db2b162b3c",
    "data-name": "Mobile_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "8a866f5c-95d1-409d-8a42-0f195f090f29",
    "data-name": "Network_ic_hi"
  }, /*#__PURE__*/React.createElement("g", {
    id: "6c17257c-c57f-4f5d-9076-037f9d17cb74",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("g", {
    id: "2ffc0881-1f0a-46a8-b69e-28640fc046cd",
    "data-name": "Network_signal_ic_mid"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#f4f4f4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("line", {
    x1: 67.82,
    y1: 172.01,
    x2: 111,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124,
    y1: 172.01,
    x2: 81,
    y2: 124.01,
    fill: "none",
    stroke: "#000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  })), /*#__PURE__*/React.createElement("path", {
    d: "M127,169.34l-25.64-28.62,12.63-14a4,4,0,1,0-5.95-5.35L96,134.73,84,121.34a4,4,0,1,0-6,5.34l12.57,14L64.84,169.33a4,4,0,1,0,5.95,5.35L96,146.7l25.06,28a4,4,0,0,0,6-5.34Z",
    transform: "translate(0 0)",
    opacity: 0.2,
    fill: "url(#e2c50020-0971-48bc-aa26-0af83b7d4a47)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.06
  }, /*#__PURE__*/React.createElement("path", {
    d: "M95.08,133.73l-4.48,5L78,124.67a4,4,0,0,1-.88-1.7,4,4,0,0,0,.88,3.7l12.57,14,5.38-6Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.67,173a4,4,0,0,1-5.65-.31l-24.16-27-.9,1,25.06,28a4,4,0,0,0,6.84-3.64A4,4,0,0,1,126.67,173Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M114,124.68l-12.63,14-5.38,6-25.17,28A4,4,0,0,1,64,171a4,4,0,0,0,6.83,3.65L96,146.7l5.38-6,12.63-14a4,4,0,0,0,.89-3.7A4,4,0,0,1,114,124.68Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,176a4,4,0,0,1-3.86-3L96,81.62,71.68,173A4,4,0,0,1,64,171L92.13,65A4,4,0,0,1,96,62h0a4,4,0,0,1,3.86,3l28,106a4,4,0,0,1-3.87,5Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.87,171,100.66,68H91.33L64,171A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.87,65A4,4,0,0,0,96,62h0a4,4,0,0,0-3.87,3l-.8,3h9.33Z",
    transform: "translate(0 0)",
    fill: "#4a4d4e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.86,171a4,4,0,0,1-7.73.06L96,79.62,71.68,171A4,4,0,0,1,64,171h0A4,4,0,0,0,71.68,173L96,81.62,120.13,173a4,4,0,1,0,7.73-2Z",
    transform: "translate(0 0)",
    opacity: 0.06
  }))), /*#__PURE__*/React.createElement("path", {
    id: "f5bb05ca-c784-4159-b6ec-8f81a32319a0",
    "data-name": "<Pfad>",
    d: "M152.17,19.5a72.74,72.74,0,0,1,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "dd91076e-5fc2-4be0-9e98-e2bfa11ba8b8",
    "data-name": "<Pfad>",
    d: "M136.6,34.39a52,52,0,0,1,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "144720db-7104-40ed-853d-b29cf20a956a",
    "data-name": "<Pfad>",
    d: "M121.3,49.7a30.24,30.24,0,0,1,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "7f2b1ac2-68d8-4c08-af04-bd524427b493",
    "data-name": "<Pfad>",
    d: "M38.9,19.5a72.74,72.74,0,0,0,0,102.91",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "41afa462-f09b-4d29-bf69-6d394a552099",
    "data-name": "<Pfad>",
    d: "M54.48,34.39a52,52,0,0,0,0,73.53",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("path", {
    id: "51702bf3-0cac-4498-99b0-b9adce493862",
    "data-name": "<Pfad>",
    d: "M69.78,49.7a30.24,30.24,0,0,0,0,42.72",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4.29
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M153.62,121.93a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A74.68,74.68,0,0,0,175.5,70,74.65,74.65,0,0,1,153.62,121.93Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M153.86,70.16A53.94,53.94,0,0,1,138,107.44a2.12,2.12,0,0,1-3.4-.52,2.14,2.14,0,0,0,3.4,2.52A54,54,0,0,0,153.86,70.16Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.23,92.56a2.09,2.09,0,0,1-1.89-1.14,2.14,2.14,0,0,0,3.4,2.52,32.13,32.13,0,0,0,9.46-22.88c0-.33,0-.67,0-1a32.11,32.11,0,0,1-9.44,21.88A2.14,2.14,0,0,1,121.23,92.56Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.9,122.55a2.14,2.14,0,0,1-1.52-.63A74.65,74.65,0,0,1,15.51,70a74.68,74.68,0,0,0,21.88,54,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.48,108.07a2.14,2.14,0,0,1-1.52-.63A53.94,53.94,0,0,1,37.15,70.16,54,54,0,0,0,53,109.44a2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.78,92.56a2.14,2.14,0,0,1-1.52-.63,32.11,32.11,0,0,1-9.44-21.88c0,.33,0,.67,0,1a32.13,32.13,0,0,0,9.46,22.88,2.14,2.14,0,0,0,3.4-2.52,2.09,2.09,0,0,1-1.89,1.14Z",
    transform: "translate(0 0)"
  })), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 45.23,
    x2: 96,
    y2: 64.5,
    fill: "none",
    stroke: "#4a4d4e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 4
  })))))))))))))))))))), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_network__signal;
exports.default = _default;